__turbopack_context__.v({
  "container": "HomeDeviceView-module___iqopa__container",
  "pill": "HomeDeviceView-module___iqopa__pill",
});
